import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="category-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block border border-accent-300 text-accent-600 text-xs font-medium px-4 py-1.5 rounded-full">
              分类浏览
            </span>
            <h2 id="category-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
              探索你喜欢的<strong>漫画类型</strong>
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
              十大分类，涵盖热血、恋爱、奇幻、武侠等多种题材，总有一款适合你
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-100 hover:bg-primary-500 rounded-xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer text-center"
              >
                <div className="w-12 h-12 mx-auto mb-3 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center transition-colors">
                  <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
                </div>
                <h3 className="font-sans text-sm font-semibold text-foreground-800 group-hover:text-background-50 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 group-hover:text-background-50/70 transition-colors mt-1">
                  {cat.count.toLocaleString()} 部
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}